import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
};

export const useHandleTransition = ({ hotelID }: Props) => {
	const navigate = useNavigate();

	/**
	 * 宿泊券一覧への遷移
	 */
	const onTransitionToVoucherList = useCallback(() => {
		navigate(generatePath(PATHS.HOTEL.MARKETING.VOUCHER.TOP, { hotelID }));
	}, [hotelID, navigate]);

	return {
		onTransitionToVoucherList,
	};
};
